import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { useIntl } from "react-intl";
import AddIcon from "@mui/icons-material/Add";
import BusinessRuleResponsiveModal from "../BusinessRuleResponsiveModal";
import { KpiTypeField, KpiTypeFieldParams } from "./BusinessRuleConditionField";

/**
 * BusinessRulePerimeterAdd component.
 * Offer Perimeter addition.
 */
export const BusinessRuleConditionAdd = ({
  onSubmit,
}: {
  onSubmit: (params: KpiTypeFieldParams) => void;
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [haveBeenSubmit, setHaveBeenSubmit] = useState<boolean | null>(null);
  const [kpi, setKpi] = useState<KpiTypeFieldParams>({
    kpiType: null,
    kpi: null,
    kpiValue: null,
    kpiOperator: null,
  });

  /**
   * On submit, close modal and call onSubmit function.
   */
  useEffect(() => {
    if (haveBeenSubmit) {
      if (kpi.kpiType && kpi.kpi && kpi.kpiValue && kpi.kpiOperator) {
        onSubmit(kpi);
        setKpi({
          kpiType: null,
          kpi: null,
          kpiValue: null,
          kpiOperator: null,
        });
      }
      setOpen(false);
      setHaveBeenSubmit(false);
    }
  }, [haveBeenSubmit, onSubmit, kpi]);

  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => setOpen(true)}
        size="medium"
        sx={{ marginTop: 1 }}
      >
        <AddIcon />
      </IconButton>
      <BusinessRuleResponsiveModal
        disabled={!kpi.kpiType || !kpi.kpi || !kpi.kpiValue || !kpi.kpiOperator}
        onClose={() => setOpen(false)}
        open={open}
        onSubmit={() => setHaveBeenSubmit(true)}
        title={intl.formatMessage({
          id: "BUSINESS_RULE_CONDITION_ADD_NEW_KPI",
        })}
      >
        <KpiTypeField onChange={setKpi} />
      </BusinessRuleResponsiveModal>
    </>
  );
};
